import React from 'react';

import PropTypes from 'prop-types';

import {
  WhyChooseVodacomFibreTerms,
  WhyChooseVodacomFibreFormTerms
} from 'src/Common/constants';

import './WhyChooseVodacomFibre.css';

function WhyChooseVodacomFibre(props) {

  const renderCards = () => {

    const terms = WhyChooseVodacomFibreFormTerms;

    return terms.map((item, index) => (

      <div key={ index } className="whyChooseVodacomFibre-card">

        <div className="whyChooseVodacomFibre-icon">{ item.icon }</div>

        <div>
          <h3 className="whyChooseVodacomFibre-heading">{ item.heading }</h3>
          <p className="whyChooseVodacomFibre-description">{ item.description }</p>
        </div>
      </div>
    ));
  };

  return (

    <div className="whyChooseVodacomFibre-container">

    { props.isForm &&
      <h3 className="whyChooseVodacomFibre-text">Why Choose Vodacom Fibre?</h3>
    }

      <div className="whyChooseVodacomFibre-card-container">{ renderCards() }</div>
    </div>
  );
}

WhyChooseVodacomFibre.propTypes ={
  isForm: PropTypes.bool
};

WhyChooseVodacomFibre.defaultProps = {
  isForm: true
};

export default WhyChooseVodacomFibre;
